import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface ToastMessage {
  severity?: string;
  summary?: string;
  detail?: string;
  life?: number;
  closable?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  showToastSub = new Subject<ToastMessage>();
  showToast$ = this.showToastSub.asObservable();

  /**
   * Show a toast message in the application
   * @param message
   */
  showToast(message: ToastMessage): void {
    this.showToastSub.next(message);
  }
}
